import { useSearchParams } from 'react-router-dom';

/**
 * Ouverture du formulaire de création, portée par l'URL.
 *
 * Le bouton d'action navigue vers `?nouveau=1` ; l'écran s'ouvre en
 * conséquence. Le geste de retour d'Android referme donc le formulaire au lieu
 * de quitter l'écran — c'est ce qu'attend un utilisateur, et cela évite un état
 * partagé entre la barre d'onglets et chaque écran.
 */
export function useCreationPanel(): [boolean, (open: boolean) => void] {
  const [params, setParams] = useSearchParams();
  const open = params.get('nouveau') === '1';

  function setOpen(value: boolean): void {
    const next = new URLSearchParams(params);
    if (value) next.set('nouveau', '1');
    else next.delete('nouveau');
    // On remplace en fermant : sans cela, revenir en arrière rouvrirait le
    // formulaire qu'on vient d'abandonner.
    setParams(next, { replace: !value });
  }

  return [open, setOpen];
}
